import React from 'react';
import { FormControl, InputGroup, Button, Media } from 'react-bootstrap';
import notifier from '../../../_utils/notifier';

const copy = require('clipboard-copy');

const CouponsItem = (props) => {
  const handleClick = () => {
    copy(props.code);
    notifier.success(gettext('Промокод успешно скопирован'));
  };

  return <Media className='media-border-bottom my-3'>
    <Media.Body className='flex-wrap'>
      <p>{ gettext('Скидка') }: <span className='font-weight-bold'>{ props.display_value }</span>
        { props.valid_date != '-' && <span> ({ gettext('годен до') } { props.valid_date })</span> }
      </p>
      <InputGroup className="mb-3">
        <FormControl
          aria-label={ gettext('Скопировать промокод') }
          value={ props.code }
          readOnly={ true }/>
        <InputGroup.Append>
          <Button variant="outline-secondary" title={ gettext('Скопировать промокод') } onClick={ handleClick }>
            <i className='icon icon-floppy'></i>
          </Button>
        </InputGroup.Append>
      </InputGroup>
      { props.content_object && <p className="mt-2 small">
        { gettext('Промокод может быть использован только для покупки')} <a href={ props.content_object.url }
                                                                            title={ gettext('Перейти') }
                                                                            className="font-weight-bold">
        { props.content_object.title }
      </a>
      </p> }
      { props.type_name && <p className="mt-2 small">
        { gettext('Промокод может быть использован только для покупки товаров из раздела') } {' '}
        <a href={ props.type_url } title={ gettext('Перейти') } className="font-weight-bold">{ props.type_name }</a>
      </p> }
    </Media.Body>
  </Media>
};

export default CouponsItem;